export const hasValue = (any: any) => {
  return any !== null && any !== undefined && !isNaN(any);
};
